import Ajax from '../../../../util/ajax';
export function zigbeeOff(nid, eid) {
    return (dispatch) => {
        const ajax = new Ajax(dispatch, true);
        const url = '/zigbee/' + nid + '/ep/' + eid + '/cluster/6/command/off';
        ajax.post(url);
    };
}
